import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IUsersContext, UsersContext } from '../../usersState/usersContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Users.module.scss';

const Users: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, users, currentPage, countOfItems } = useContext<IUsersContext>(UsersContext);

	return (
		<>
			{users.usersCount ? (
				<div className={style.container} data-test="Users">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={users.usersCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Users;
